import React, { useContext, useEffect, useState } from "react";
import { ShopContext } from "../context/ShopContext";
import Title from "./Title";
import ProductCard from "./ProductCard";

const BestSeller = () => {
  const { products,reviews } = useContext(ShopContext);
  const [bestSeller, setBestSeller] = useState([]);

   // Calculate average rating for a product
  const getAverageRating = (productId) => {
    const productReviews = reviews.filter((review) => review.productId === productId);
    if (productReviews.length === 0) return 0;
    const sum = productReviews.reduce((acc, review) => acc + review.rating, 0);
    return sum / productReviews.length;
  };

  // Format price with currency
  const formatPrice = (price) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 0,
    }).format(price);
  };

  useEffect(() => {
    const bestProduct = products.filter((item) => item.bestseller);
    setBestSeller(bestProduct.slice(0, 5));
  }, [products]);

  return (
    <div className="my-10">
      <div className="text-center text-3xl py-8">
        <Title text1={"BEST"} text2={"CURTAINS"} />
        <p className="w-3/4 m-auto text-xs sm:text-sm md:text-base text-gray-600">
          Discover our Bestsellers – the perfect blend of style, quality, and
          customer favorites. These top-rated curtains have quickly become the
          go-to choice for homeowners looking to elevate their interiors.
          Featuring timeless designs, superior craftsmanship, and premium
          materials, our bestsellers offer unbeatable style and functionality.
        </p>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 gap-y-6">
          {bestSeller.map((product, index) => (
            <ProductCard
                  key={product._id}
                  product={product}
                  formatPrice={formatPrice}
                  getAverageRating={getAverageRating}
                  reviews={reviews}
                />
          ))}
        </div>
    </div>
  );
};

export default BestSeller;
